<script>
  import MultiSelectFilter from '@/components/grid/filters/shared/MultiSelectFilter';

  export default {
    extends: MultiSelectFilter,
    computed: {
      placeholder() { return this.$gettext('Select status'); },
      selectList() {
        return [
          {id: '10', name: this.$gettext('Draft')},
          {id: '15', name: this.$gettext('Transferred')},
          {id: '20', name: this.$gettext('Public access')},
          {id: '30', name: this.$gettext('Invited')},
          {id: '40', name: this.$gettext('Applied')},
          {id: '50', name: this.$gettext('Accepted')},
          {id: '60', name: this.$gettext('Rejected')},
          {id: '65', name: this.$gettext('In Progress')},
          {id: '70', name: this.$gettext('Review Requested')},
          {id: '75', name: this.$gettext('Changes Required')},
          {id: '80', name: this.$gettext('Finished')},
          {id: '90', name: this.$gettext('Cancelled')},
        ];
      },
    },
  };
</script>
